var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgNotConnected = function SvgNotConnected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "currentColor"
  })));
};
export default SvgNotConnected;